<template>
  <div>
    <form @submit.prevent="createUpdateVariation">
      <modal
        v-show="isVariationModalVisible"
        @close="closeVariationModal"
        footer
      >
        <template v-slot:title>
          <h5>Add Variation</h5>
        </template>
        <template v-slot:body>
          <div class="">
            <div class="form-group">
              <label for="name">Variation Name</label>
              <input
                type="text"
                v-model.trim="variation.name"
                class="form-control"
                placeholder="i.e. Berekete,   e.t.c"
              />
            </div>
            <div class="form-group">
              <label for="name">Variation Amount</label>
              <input
                type="text"
                v-model.number="variation.amount"
                class="form-control"
                placeholder="i.e. Berekete,   e.t.c"
              />
            </div>
            <div class="form-group">
              <label for="name">Slug Name</label>
              <input
                type="text"
                v-model.trim="variation.slug"
                class="form-control"
                placeholder="i.e. Berekete,   e.t.c"
              />
            </div>
            <div class="form-group">
              <label for="role">Fixed Price</label>
              <select
                name="role"
                id="role"
                v-model="variation.fixed_price"
                @change="changeStatus()"
                class="form-control"
              >
                <option value="yes">Yes</option>
                <option value="no">no</option>
              </select>
            </div>
            <div class="form-group">
              <label for="role">Status</label>
              <select
                name="role"
                id="role"
                v-model="variation.status"
                @change="changeStatus()"
                class="form-control"
              >
                <option value="" selected disabled>Select status</option>
                <option
                  :value="status.slug"
                  v-for="status in statuses"
                  :key="status.id"
                  >{{ status.name }}</option
                >
              </select>
            </div>
          </div>
        </template>
        <template v-slot:footer>
          <button
            type="submit"
            class="button"
            :disabled="
              variationModalLoading || !permissions.includes('dashboard')
            "
            :class="
              permissions.includes('dashboard')
                ? ''
                : 'disabled cursor-not-allowed'
            "
          >
            <span class="custom-loader" v-if="variationModalLoading">
              <loader-icon size="1.5x" class="custom-class"></loader-icon>
              <span style="font-weight: 600; text-transform: initial;">{{
                variation.id ? "Updating variation..." : "Adding Variation..."
              }}</span>
            </span>
            <span v-else>
              {{ variation.id ? "Update Variation" : "Add Variation" }}
            </span>
          </button>
          <button
            type="button"
            class="btn btn-secondary"
            data-dismiss="modal"
            @click="closeVariationModal"
          >
            Cancel
          </button>
        </template>
      </modal>
    </form>

    <form @submit.prevent="updateGroupVariation">
      <CModal
        v-show="isGroupUpdateModalVisible"
        @close="showGroupVariationModal"
        footer
        modalIsLarge
      >
        <template v-slot:title>
          <h5>Update Group Variation</h5>
        </template>
        <template v-slot:body>
          <div
            style="border-color: black"
            class="row border-bottom p-2"
            v-for="(item, index) in variations"
            :key="index"
          >
            <div class="col-md-4">
              <div class="form-group mb-1">
                <label for="">Name</label>
                <input type="text" class="form-control" v-model="item.name" />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group mb-1">
                <label for="">Amount</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="item.amount"
                  @keypress="isNumber($event)"
                />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group mb-1">
                <label for="">Slug</label>
                <input type="text" class="form-control" v-model="item.slug" />
              </div>
            </div>
            <div class="col-md-4 d-none">
              <div class="form-group mb-1">
                <label for="">Shago Code</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="item.shago_code"
                />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group mb-1">
                <label for="">Vt Pass Code</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="item.vtpass_code"
                />
              </div>
            </div>            
            <div class="col-md-4">
              <div class="form-group mb-1">
                <label for="">Status</label>
                <select
                  name=""
                  id=""
                  class="form-control"
                  v-model="item.status"
                >
                  <option value="" disabled selected>Please Select</option>
                  <option value="active">Active</option>
                  <option value="suspended">Suspended</option>
                  <option value="inactive">Inactive</option>
                </select>
              </div>
            </div>
          </div>
        </template>
        <template v-slot:footer>
          <button
            class="btn btn-primary"
            @submit.prevent="updateGroupVariation"
            :disabled="!groupVariationIsValid || groupLoading"
          >
            <span class="custom-loader" v-if="groupLoading">
              <loader-icon size="1.5x" class="custom-class"></loader-icon>
              <span style="font-weight: 600; text-transform: initial;">
                Updating ...
              </span>
            </span>
            <span v-else>
              Update Group Variation
            </span>
          </button>
          <button
            @click.prevent="showGroupVariationModal"
            class="btn btn-secondary"
          >
            Close
          </button>
        </template>
      </CModal>
    </form>

    <div
      v-if="getServiceLoading"
      style="display: flex; top: 0px; position: fixed; left: 0px; right: 0px; bottom: 0px; background-color: rgba(247, 247, 247, 0.9); z-index: 9999; justify-content: center; align-items: center;"
    >
      <div>
        <div>
          <h3>Getting Service details ready...</h3>
        </div>
      </div>
    </div>

    <div class="order--main-content">
      <div class="row align-items-center justify-content-between mb-2">
        <div class="col">
          <router-link :to="{ name: 'Services' }" class="arrow_text">
            <chevron-left-icon
              size="1.5x"
              class="custom-class"
              style="vertical-align: top;"
            ></chevron-left-icon>
            <span class="back">Back</span>
          </router-link>
          <!-- <h1 class="mb-2 font-regular">Ads</h1> -->
        </div>
      </div>

      <h1 class="mt-2 mb-3 font-regular" v-if="serviceDetails">
        &nbsp;&nbsp; {{ serviceDetails.name }} Service
      </h1>
      <div class="row mb-5">
        <div class="col-lg-12">
          <ul class="nav nav-tabs nav-overflow header-tabs">
            <li class="nav-item">
              <a
                class="nav-link"
                href="javascript:void(0)"
                v-on:click="activetab = 1"
                v-bind:class="[activetab === 1 ? 'active' : '']"
              >
                Configuration
              </a>
            </li>
            <li
              class="nav-item"
              v-if="serviceDetails && serviceDetails.variations.length > 0"
            >
              <a
                class="nav-link"
                href="javascript:void(0)"
                v-on:click="activetab = 2"
                v-bind:class="[activetab === 2 ? 'active' : '']"
              >
                Variation
              </a>
            </li>
            <li class="nav-item d-none">
              <a
                class="nav-link"
                href="javascript:void(0)"
                v-on:click="activetab = 3"
                v-bind:class="[activetab === 3 ? 'active' : '']"
              >
                Customer Level Setup
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div class="row" v-if="activetab === 1">
        <div class="col-md-12" v-if="serviceDetails">
          <!-- General Information -->
          <div class="card card--no-shadow card-profile">
            <div class="card-header">
              <h3 class="font-weight-600 mb-0">Profile Information</h3>
            </div>
            <div class="card-content">
              <div class="card-body">
                <form @submit.prevent="updateServiceConfig">
                  <!-- General Information -->
                  <div class="actions-toolbar pb-2">
                    <h5 class="actions-title">General Information</h5>
                  </div>
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="name">Name</label>
                        <input
                          type="text"
                          class="form-control"
                          v-model.trim="serviceDetails.name"
                          placeholder="Name"
                          name="name"
                        />
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="variation label">Variation Label</label>
                        <input
                          type="text"
                          id="variation label"
                          class="form-control"
                          v-model.trim="serviceDetails.variation_label"
                          placeholder="If Seen, Label Not Available"
                          name="variation label"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="phone_number">Biller Identifier</label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="serviceDetails.biller_identifier_name"
                          placeholder="Biller Identifier Name"
                        />
                      </div>
                    </div>
                    <!-- I only used this for the mean time because the api options for providers are not available -->
                    <!-- <div class="col-md-6">
                      <div class="form-group">
                        <label for="status">Provider</label> <br />
                        <select
                          id="select"
                          class="form-select fw-two form-control"
                          v-model="serviceDetails.provider_id"
                        >
                          <option
                            :value="serviceDetails.provider_id"
                            class="mb-2"
                            >{{ serviceDetails.provider.name }}</option
                          >
                        </select>
                      </div>
                    </div> -->
                  </div>
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="full_name">Min Amount</label>
                        <input
                          type="text"
                          class="form-control"
                          @keyup="formatAmountWithComma"
                          v-model.trim="serviceDetails.min_amount"
                          placeholder="Min Amount"
                          name="fullname"
                        />
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="max_amount">Max Amount</label>
                        <input
                          type="text"
                          id=""
                          class="form-control"
                          @keyup="formatWithComma"
                          v-model.trim="serviceDetails.max_amount"
                          placeholder="max amount"
                          name="max amount"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="phone_number">Convenience Fee</label>
                        <input
                          type="text"
                          class="form-control"
                          @keyup="formatFeeWithComma"
                          v-model.trim="serviceDetails.convinience_fee"
                          placeholder="Convenience Fee"
                        />
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="status">Edit Variant Amount</label> <br />
                        <select
                          id="select"
                          class="form-select fw-two form-control"
                          v-model="serviceDetails.edit_variant_amount"
                        >
                          <option value="yes" class="mb-2">Yes</option>
                          <option value="no" class="mb-2">
                            No
                          </option>
                        </select>
                      </div>
                    </div>
                    
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="status">Use Rewards</label> <br />
                        <select
                          id="select"
                          class="form-select fw-two form-control"
                          v-model="serviceDetails.use_rewards"
                        >
                          <option value="yes" class="mb-2">Yes</option>
                          <option value="no" class="mb-2">
                            No
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="status">Status</label> <br />
                        <select
                          id="select"
                          class="form-select fw-two form-control"
                          v-model="serviceDetails.status"
                        >
                          <option value="active" class="mb-2">Active</option>
                          <option value="in-active" class="mb-2">
                            Inactive
                          </option>
                        </select>
                      </div>
                    </div>
                    <!-- you did not specify the category_id in get service data instance -->
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="status">Category</label> <br />
                        <select
                          id="select"
                          class="form-select fw-two form-control"
                          v-model="serviceDetails.service_category_id"
                        >
                          <option
                            :value="category.id"
                            v-for="category in categories"
                            :key="category.id"
                            >{{ category.name }}</option
                          >
                        </select>
                      </div>
                    </div>
                    <!-- <div class="col-md-6">
                      <div class="form-group">
                        <label for="status">Validate Service Provider</label>
                        <br />
                        <select
                          id="select"
                          class="form-select fw-two form-control"
                        >
                          <option value="active" class="mb-2">Active</option>
                          <option value="in-active" class="mb-2">Inactive</option>
                        </select>
                      </div>
                    </div> -->
                  </div>

                  <button
                    type="submit"
                    class="button"
                    :disabled="
                      updateConfiguarationLoading ||
                        !permissions.includes('update-service')
                    "
                    :class="
                      permissions.includes('update-service')
                        ? ''
                        : 'disabled cursor-not-allowed'
                    "
                  >
                    <span
                      class="custom-loader"
                      v-if="updateConfiguarationLoading"
                    >
                      <loader-icon
                        size="1.5x"
                        class="custom-class"
                      ></loader-icon>
                      <span style="font-weight: 600; text-transform: initial"
                        >Updating profile...</span
                      >
                    </span>
                    <span v-else> Save changes </span>
                  </button>
                </form>
              </div>
            </div>
          </div>

          <hr />
        </div>
      </div>

      <div class="row" v-if="activetab === 2">
        <div class="col-md-12" v-if="serviceDetails">
          <div class="card card--no-shadow">
            <div class="card-header">
              <div class="row justify-content-between align-items-center">
                <div class=" col-auto">
                  <h4 class="card-title">Variations</h4>
                </div>
                <div class="col-auto">
                  <button
                    class="button button--outline text-uppercase"
                    @click="showGroupVariationModal"
                  >
                    Update Variation Group
                  </button>
                </div>
              </div>
            </div>
            <div class="card-content">
              <div class="card-body">
                <CDataTable
                  :items="serviceDetails.variations"
                  :fields="variation_fields"
                  :items-per-page="small ? 10 : 5"
                  pagination
                  sorter
                  tableFilter
                >
                  <template #action="{item}">
                    <td class="table--action-mobile">
                      <button
                        class="button btn-succes"
                        @click="showUpdateVariationModal(item)"
                      >
                        Update
                      </button>
                    </td>
                  </template>
                </CDataTable>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from "@/services/api.service";
import CDataTable from "@/components/CDataTable.vue";
import CPagination from "@/components/CPagination.vue";
import ErrorService from "@/services/error.service";
import Swal from "sweetalert2";
import { ChevronLeftIcon } from "vue-feather-icons";

import CModal from "../../components/CModal.vue";
const variation_fields = ["name", "amount", "slug", "status", "action"];

export default {
  name: "ServiceComponent",
  props: {
    slug: {
      type: [String, Number],
      required: true
    }
  },
  components: {
    ChevronLeftIcon,
    CDataTable,
    CPagination,
    CModal
  },

  data() {
    return {
      statuses: [
        { id: "1", name: "Active", slug: "active" },
        { id: "2", name: "In-Active", slug: "in-active" }
      ],
      variation_fields,
      isVariationModalVisible: false,
      variationModalLoading: false,
      small: true,
      activetab: 1,
      serviceDetails: null,
      getServiceLoading: false,
      updateConfiguarationLoading: false,
      category_id: "",
      getCategoriesLoading: false,
      variation: {
        service_id: this.slug
      },
      categories: [],
      variations: [],
      isGroupUpdateModalVisible: false,
      groupLoading: false
    };
  },
  computed: {
    groupVariationIsValid() {
      return this.variations.every(
        element =>
          element.name !== "" &&
          element.amount !== "" &&
          element.slug !== "" &&
          element.status !== ""
      );
    },
    permissions() {
      let permissions = this.$store.getters.permissions;
      return permissions;
    },
    removeCommaFromMaxAccount() {
      return this.serviceDetails.max_amount.toString().replace(/,/g, "");
    },
    removeCommaFromMinAccount() {
      return this.serviceDetails.min_amount.toString().replace(/,/g, "");
    },
    removeCommaFromFee() {
      return this.serviceDetails.convinience_fee.toString().replace(/,/g, "");
    }
  },

  methods: {
    // updateGroupVariation() {},
    isNumber: function(evt) {
      console.log(evt.key);
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    showGroupVariationModal() {
      console.log("Here Inside The function");
      this.isGroupUpdateModalVisible = !this.isGroupUpdateModalVisible;
    },
    formatWithComma() {
      let result = this.serviceDetails.max_amount
        .toString()
        .replace(/\D/g, "")
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      this.$nextTick(() => (this.serviceDetails.max_amount = result));
    },
    formatAmountWithComma() {
      let result = this.serviceDetails.min_amount
        .toString()
        .replace(/\D/g, "")
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      this.$nextTick(() => (this.serviceDetails.min_amount = result));
    },
    formatFeeWithComma() {
      let result = this.serviceDetails.convinience_fee
        .toString()
        .replace(/\D/g, "")
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      this.$nextTick(() => (this.serviceDetails.convinience_fee = result));
    },
    showUpdateVariationModal(item) {
      this.variation = Object.assign({}, item);
      this.showVariationModal();
      console.log(this.variation);
    },
    closeVariationModal() {
      this.isVariationModalVisible = false;
      this.variation = {};
    },
    showVariationModal() {
      this.isVariationModalVisible = true;
    },
    async updateGroupVariation() {
      this.groupLoading = true;
      try {
        const response = await ApiService.post(
          "bills/update-service-group-variation",
          {
            service_id: this.slug,
            variations: this.variations
          }
        );
        this.showGroupVariationModal();
        Swal.fire({
          title: "Success",
          text: response.data.response_message,
          icon: "success",
          timer: 3000,
          confirmButtonText: "Close",
          showConfirmButton: false
        });
        this.getService();

        this.groupLoading = false;
      } catch (error) {
        console.log(error.response);
        this.groupLoading = false;
        this.showGroupVariationModal();
        let _error = error.response.data;
        ErrorService.displayErrorAlert(_error);
      }
    },
    async createUpdateVariation() {
      try {
        this.variationModalLoading = true;
        const response = await ApiService.post(
          "bills/update-service-variation",
          this.variation
        );
        this.variationModalLoading = false;

        // this.ads.push(response.data.data);

        this.closeVariationModal();
        this.variation = {};
        setTimeout(() => this.getService(), 3000);

        // Fire swal modal
        Swal.fire({
          title: "Success",
          text: response.data.response_message,
          icon: "success",
          timer: 3000,
          confirmButtonText: "Close",
          showConfirmButton: false
        });
      } catch (error) {
        this.variationModalLoading = false;
        let _error = error.response.data;
        ErrorService.displayErrorAlert(_error);
      }
    },
    async getService() {
      try {
        this.getServiceLoading = true;
        const response = await ApiService.get(`bills/service/${this.slug}`);

        this.serviceDetails = response.data.data;
        this.variations = response.data.data.variations;
        this.formatAmountWithComma();
        this.formatWithComma();
        this.formatFeeWithComma();
        this.getServiceLoading = false;
      } catch (error) {
        console.log(error.response);
        this.getServiceLoading = false;
      }
    },
    async updateServiceConfig() {
      let data = {
        name: this.serviceDetails.name,
        biller_identifier_name: this.serviceDetails.biller_identifier_name,
        convinience_fee: parseFloat(this.removeCommaFromFee),
        min_amount: parseFloat(this.removeCommaFromMinAccount),
        max_amount: parseFloat(this.removeCommaFromMaxAccount),
        edit_variant_amount: this.serviceDetails.edit_variant_amount,
        status: this.serviceDetails.status,
        use_rewards: this.serviceDetails.use_rewards,
        // provider_id: this.serviceDetails.provider_id,
        // provider_validate_id: this.serviceDetails.provider_validate_id,
        variation_label: this.serviceDetails.variation_label
      };
      console.log(data);
      try {
        this.updateConfiguarationLoading = true;
        const response = await ApiService.post(
          `bills/update-service/${this.slug}`,
          data
        );

        this.updateConfiguarationLoading = false;
        // Fire swal modal
        Swal.fire({
          title: "Success",
          text: response.data.response_message,
          icon: "success",
          timer: 3000,
          confirmButtonText: "Close",
          showConfirmButton: false
        });
        setTimeout(() => {
          this.getService();
        }, 3000);
      } catch (error) {
        this.updateConfiguarationLoading = false;
        let _error = error.response.data;
        ErrorService.displayErrorAlert(_error);
      }
    },
    async getCategories() {
      try {
        this.getCategoriesLoading = true;
        const response = await ApiService.get("bills/categories");
        const name = "name";

        this.categories = response.data.data;
        this.getCategoriesLoading = false;
      } catch (error) {
        console.log(error.response);
        this.getCategoriesLoading = false;
      }
    },
    getCategory(id) {
      this.categories.forEach(item => {
        if (item.id === id) {
          console.log(item);
          this.serviceDetails.category = item;
        }
        // console.log(obj);
      });
      // console.log(obj);
    }
  },
  mounted() {
    this.getService();
    this.getCategories();
  }
};
</script>

<style scoped></style>
